/**
 * Used for typings in /config
 */

import { CSSObject } from '@chakra-ui/react';
import React from 'react';
import { Inputs } from './Enums';

/**
 * Flow configs
 */

export enum FlowType {
  RISK_ANALYSIS = 'RISK-ANALYSIS',
  SALES_CONVERSATION = 'SALES_CONVERSATION',
  COMPANY_SCAN = 'COMPANY_SCAN',
}

export interface FlowConfig {
  [flowId: string]: {
    /** Title which is displayed in the browser window */
    title: string;
    /** The appShell of the Flow UI */
    appShell: React.FC<React.PropsWithChildren<unknown>>;
    /** The loading view of the Flow UI */
    loadingView: React.FC<React.PropsWithChildren<unknown>>;
    /** The error view of the Flow UI */
    errorView: React.FC<React.PropsWithChildren<{ error?: string | unknown }>>;
    /** The visual environment that the Flow UI should render */
    visualEnvironment: React.FC<React.PropsWithChildren<unknown>>;
    /** The main route for the Flow UI */
    src: string;
    /** The type of flow that the Flow UI renders */
    flowType: FlowType;
  };
}

/**
 * Individual input config typings
 */
export interface InputConfigProps {
  /** Used for styling the input */
  styling: CSSObject;
  /** Used defining configuring the input itself */
  config: {
    isTitleHidden?: boolean;
    isActionIncluded?: boolean;
  };
  /** Used for defining the grid config that is dependant on the inputs it contains */
  gridConfig: {
    isFullScreen?: boolean;
    isContinueButtonHidden?: boolean;
    isFullWidth?: boolean;
    isExpandedGrid?: boolean;
  };
  groupConfig?: {
    isGroupTitleHidden?: boolean;
  };
}

export type InputConfig = InputConfigProps & {
  flowOverride?: {
    [flowId: string]: InputConfigProps;
  };
};

export type InputComponentsConfigType = {
  [key in Inputs]: InputConfig;
};
